export const FEATURES = {
  ADMIN_AVAILABILITY: 'ADMIN_AVAILABILITY',
  SMART_INBOX_PRIMARY_CARE_TEAM: 'SMART_INBOX_PRIMARY_CARE_TEAM',
};
